import React from 'react';
import PropTypes from 'prop-types';
import SMConst from 'lib/SMConst';
import SMGraphQLClient from 'lib/SMGraphQLClient';
import 'babel-polyfill';
import SMSubdomainUrlHelper from 'components/helpers/SMSubdomainUrlHelper';
import { companyManagedFragment } from 'fragments';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMAccountMenuView extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      display: this.props.display,
      companies: [],
    };
  }
  componentDidMount() {
    $(document).on("SMHideBaloon", this.hide.bind(this));

    this.requestResource();
  }

  componentWillUnmount() {
    $(document).off("SMHideBaloon", this.hide);
  }

  async requestResource(){
    const apiClient = new SMGraphQLClient();
    const query = `
      query {
        viewer {
          companies(filter: MANAGED) {
            results{
              ... on Company {
                ${companyManagedFragment}
              }
            }
          }
        }
      }`;
    const obj = await apiClient.request(query);

    if (!obj) return false;
    if (obj.errors) {
      console.log(obj.errors);
      return false;
    }

    this.setState({
      companies: obj.data.viewer.companies.results
    });
  }

  show(e) {
    $(document).trigger("SMHideBaloon");
    this.setState({display: SMConst.Display.Visible});
  }

  hide(e) {
    this.setState({display: SMConst.Display.Hidden});
  }

  toggle(e){
    e.stopPropagation();
    e.preventDefault();
    if (this.state.display == SMConst.Display.Hidden) {
      this.show(e);
    } else {
      this.hide(e);
    }
  }

  render() {
    const user = this.props.currentUser;

    let style = {
      display: (this.state.display == SMConst.Display.Hidden) ? "none" : ""
    };
    return (
      <li>
        <a onClick={this.toggle.bind(this)} href={Routes.dashboard_index_path()} className="site-header__nav-user">
          <img src={this.props.currentUser.profile_image} className="site-header__nav-user-icon" />
          <p className="site-header__nav-user-name link-black link-borderless"><i className="fa fa-caret-down"></i></p>
        </a>
        <div className="baloon baloon-top site-header__nav-baloon site-header__nav-baloon-name" style={style}>
          <div className="baloon-inner">
            <ul>
              <li className="site-header__nav-baloon-user">{user.name}</li>
              <li className="site-header__nav-baloon-point"><a className="link-black" href={Routes.dashboard_points_available_point_histories_path()}>{user.point_balance.available_amount}<span className="site-header__nav-baloon-point-unit"> ポイント</span></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.dashboard_index_path()} className="link-black link-borderless">{I18n.t('dashboard.label_000311')}<i className="fa fa-angle-right fr" /></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.dashboard_favorite_lists_path()} className="link-black link-borderless">{I18n.t('dashboard.label_000004')}<i className="fa fa-angle-right fr" /></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.dashboard_reservations_path()} className="link-black link-borderless">{I18n.t('dashboard.label_000005')}<i className="fa fa-angle-right fr" /></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.dashboard_points_available_point_histories_path()} className="link-black link-borderless">{I18n.t('dashboard.label_001100')}<i className="fa fa-angle-right fr" /></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.dashboard_settings_account_path()} className="link-black link-borderless">{I18n.t('dashboard.label_000014')}<i className="fa fa-angle-right fr" /></a></li>
              <li className="site-header__nav-baloon-menu"><a href={Routes.destroy_user_session_path()} className="link-black link-borderless">{I18n.t('dashboard.label_000008')}<i className="fa fa-angle-right fr" /></a></li>
            </ul>
            {this.state.companies.length > 0 ? <h2 className="site-header__nav-baloon-title">ビジネスアカウント</h2> : null}
            <div className="site-header__nav-baloon-menu">
              {this.state.companies.map((company) => {
                return(
                  <a key={`company_${company.id}`} href={SMSubdomainUrlHelper.businessSummaryUrl(company.username)} className="link-black link-borderless">
                    <img src={company.profileImage ? company.profileImage : SMFormatHelper.defaultIcon()} alt={company.name} className="site-header__nav-baloon-business-img" />
                    <p className="site-header__nav-baloon-business-text">{company.name}</p>
                    <div className="site-header__nav-baloon-business-angle"><i className="fa fa-angle-right" /></div>
                  </a>
                );
              })}
            </div>
            {user.is_corp ?
              <p className="site-header__nav-baloon-menu site-header__nav-baloon-business-create">
                <a href={SMSubdomainUrlHelper.businessBaseUrl()} className="link-black link-borderless">ビジネスアカウントを作成<i className="fa fa-angle-right fr" />
                </a>
              </p> : null
            }
          </div>
        </div>
      </li>
    );
  }
}
SMAccountMenuView.propTypes = {
  currentUser: PropTypes.object.isRequired
};
SMAccountMenuView.defaultProps = {
  display: SMConst.Display.Hidden,
};
export default SMAccountMenuView;



// WEBPACK FOOTER //
// ./app/javascript/components/header/SMAccountMenuView.jsx